/* eslint-disable react/require-default-props */
import React from 'react';
import Check from 'assets/images/new_plans_and_prices/check-circle.svg';
import Disabled from 'assets/images/new_plans_and_prices/disabled-icon.svg';
import { ContainerList } from './styles';

interface FeatureItemProps {
  pacote: string;
  divider?: boolean;
  origin: 'cardPlan' | 'checkout';
  servicos_pacote?: {
    servico_nome: string;
  }[];
}

const FeatureItem = ({ pacote, divider, origin, servicos_pacote }: FeatureItemProps) => {
  let features: string[];

  features = [
    'Boletins de licitações',
    'Encontrar licitações',
    'Encontrar acompanhamentos',
    'Gerenciar licitações',
    'ConLicitaGO',
    'Análise de mercado',
    'Concorrentes',
    'Jurídico fácil',
    'Suporte jurídico',
    'Gerenciar documentos',
    'Monitoramento de chat',
    'Licitações Estratégicas',
    'Contratos',
    'Ata de registro de preços',
    'Pergunte ao Edital',
    'Especialista Virtual',
    'Dr. Licita',
    'Robô de Lances',
  ];

  const unavailableFeatures: Record<string, string[]> = {
    super: [
      'Monitoramento de chat',
      'Licitações Estratégicas',
      'Contratos',
      'Ata de registro de preços',
      'Pergunte ao Edital',
      'Especialista Virtual',
      'Dr. Licita',
      'Robô de Lances',
    ],
    basic: [
      'Monitoramento de chat',
      'Licitações Estratégicas',
      'Contratos',
      'Ata de registro de preços',
      'Pergunte ao Edital',
      'Especialista Virtual',
      'Dr. Licita',
      'Robô de Lances',
      'Gerenciar documentos',
    ],
    master: [
      'Monitoramento de chat',
      'Licitações Estratégicas',
      'Contratos',
      'Ata de registro de preços',
      'Pergunte ao Edital',
      'Especialista Virtual',
      'Dr. Licita',
      'Robô de Lances',
      'Gerenciar documentos',
    ],
    iaml: ['Monitoramento de chat', 'Dr. Licita', 'Robô de Lances'],
    premium: ['Dr. Licita', 'Robô de Lances'],
    advanced: ['Robô de Lances'],
    black: [],
  };

  const SERVICE_ALIASES: Record<string, string[]> = {
    'Robô de Lances': ['Robô de Lances', 'Robô de lances Inteligente'],
  };

  const hasService = (item: string, servicosApi: string[]) => {
    const servicosLower = servicosApi.map((s) => s.toLowerCase());

    const aliases = (SERVICE_ALIASES[item] || [item]).map((alias) => alias.toLowerCase());

    return aliases.some((alias) => servicosLower.includes(alias));
  };

  if (pacote?.toLowerCase() === 'iaml') {
    if (!features.includes('Curso IAML')) {
      features = ['Curso IAML', ...features];
    }

    if (servicos_pacote && servicos_pacote.length > 0) {
      const servicosApi = servicos_pacote.map((s) => s.servico_nome);

      unavailableFeatures.iaml = unavailableFeatures.iaml.filter(
        (item) => !hasService(item, servicosApi),
      );
    }
  }

  const pacoteKey = pacote?.toLowerCase();
  const indisponiveis = unavailableFeatures[pacoteKey] || [];
  const iaFeatures = ['Especialista Virtual', 'Dr. Licita', 'Pergunte ao Edital'];

  const renderList = (items: string[]) =>
    items.map((feature, index) => {
      const isAvailable = !indisponiveis.includes(feature);
      const hasIA = iaFeatures.includes(feature);
      return (
        <React.Fragment key={feature}>
          <ContainerList className="d-flex align-items-center gap-2">
            {isAvailable ? (
              <div className="d-flex justify-content-between align-items-center w-100">
                <div className="d-flex align-items-center">
                  {origin === 'checkout' ? (
                    <i
                      className="material-icons mr-2"
                      style={{ color: '#0D875E', fontSize: '20px' }}
                    >
                      check_circle
                    </i>
                  ) : (
                    <img src={Check} alt="Check" className="mr-2" />
                  )}
                  <span className="text-uppercase pt-1">{feature}</span>
                </div>
                {hasIA && <span className="badge badge-ia">IA</span>}
              </div>
            ) : (
              <div className="d-flex justify-content-between align-items-center w-100">
                <div className="d-flex align-items-center">
                  {origin === 'checkout' ? (
                    <i className="material-icons mr-2" style={{ color: 'red', fontSize: '20px' }}>
                      cancel
                    </i>
                  ) : (
                    <img src={Disabled} alt="Disabled" className="mr-2" />
                  )}
                  <span className="text-uppercase">{feature}</span>
                </div>
                {hasIA && <span className="badge badge-ia">IA</span>}
              </div>
            )}
          </ContainerList>
          {divider && index !== items.length - 1 && <hr className="m-0 w-100" />}
        </React.Fragment>
      );
    });

  if (origin === 'checkout') {
    const half = Math.ceil(features.length / 2);
    const firstHalf = features.slice(0, half);
    const secondHalf = features.slice(half);

    return (
      <div className="d-flex flex-wrap gap-4">
        <ul className="py-3 flex-fill">{renderList(firstHalf)}</ul>
        <ul className="py-3 flex-fill">{renderList(secondHalf)}</ul>
      </div>
    );
  }

  return <ul className="py-3">{renderList(features)}</ul>;
};

export default FeatureItem;
